document.addEventListener('DOMContentLoaded', () => {
    const sectionElement = document.querySelector('.pdp-section');
    if (!sectionElement) return;

    const sectionId = sectionElement.getAttribute('data-section');
    
    initGallery();
    initVariantPicker(sectionId);
    initBundles(sectionId);
});

// 1. IMAGE GALLERY (Thumbnail Clicks)
function initGallery() {
    const mainImg = document.getElementById('pdpMain');
    const thumbnails = document.querySelectorAll('.pdp-thumb, .pdp-grid-img');

    if (!mainImg || !thumbnails.length) return;

    thumbnails.forEach(thumb => {
        thumb.addEventListener('click', function() {
            document.querySelectorAll('.pdp-thumb, .pdp-grid-img').forEach(t => t.classList.remove('active'));
            this.classList.add('active');

            const newSrc = this.getAttribute('data-main-img');
            mainImg.style.opacity = '0.5'; 
            setTimeout(() => { 
                mainImg.setAttribute('src', newSrc); 
                mainImg.style.opacity = '1'; 
            }, 150);
        });
    });
}

// 2. VARIANT SELECTION (Dynamic Fetching)
function initVariantPicker(sectionId) {
    const productJsonEl = document.getElementById(`ProductJson-${sectionId}`);
    if(!productJsonEl) return;
    
    const productData = JSON.parse(productJsonEl.innerHTML);

    document.addEventListener('change', (event) => {
        if (!event.target.classList.contains('variant-input')) return;

        const input = event.target;
        
        // --- A. Update UI Classes ---
        const wrapper = input.closest('.variant-wrapper');
        const labels = wrapper.querySelectorAll('label');
        
        labels.forEach(label => {
            label.classList.remove('active');
            const checkIcon = label.querySelector('.fa-check');
            if(checkIcon) checkIcon.classList.add('d-none');
        });

        const selectedLabel = wrapper.querySelector(`label[for="${input.id}"]`);
        if (selectedLabel) {
            selectedLabel.classList.add('active');
            const checkIcon = selectedLabel.querySelector('.fa-check');
            if(checkIcon) checkIcon.classList.remove('d-none');
        }

        // --- B. Find Selected Variant Data ---
        const selectedOptions = Array.from(document.querySelectorAll('.variant-input:checked')).map(el => el.value);
        const matchedVariant = productData.variants.find(variant => {
            return variant.options.every((opt, i) => opt === selectedOptions[i]);
        });

        if (matchedVariant) {
            // Update hidden ID
            document.getElementById(`VariantId-${sectionId}`).value = matchedVariant.id;
            // Seamlessly update browser URL
            window.history.replaceState({}, '', `${window.location.pathname}?variant=${matchedVariant.id}`);
            
            // --- C. Re-render Shopify blocks via API ---
            fetch(`${window.location.pathname}?variant=${matchedVariant.id}&section_id=${sectionId}`)
                .then(res => res.text())
                .then(html => {
                    const newDoc = new DOMParser().parseFromString(html, 'text/html');
                    
                    // 1. Update Price, Inventory, Buttons
                    ['Price', 'Inventory', 'BuyButtons'].forEach(block => {
                        const elId = `${block}-${sectionId}`;
                        if(document.getElementById(elId) && newDoc.getElementById(elId)) {
                            document.getElementById(elId).innerHTML = newDoc.getElementById(elId).innerHTML;
                        }
                    });

                    // 2. Update Main Image directly from fetched HTML
                    const imageWrapperId = `ProductImageWrapper-${sectionId}`;
                    const currentImgWrapper = document.getElementById(imageWrapperId);
                    const newImgWrapper = newDoc.getElementById(imageWrapperId);
                    
                    if(currentImgWrapper && newImgWrapper) {
                        const mainImg = currentImgWrapper.querySelector('img');
                        if(mainImg) mainImg.style.opacity = '0.5';
                        
                        setTimeout(() => {
                            currentImgWrapper.innerHTML = newImgWrapper.innerHTML;
                            
                            // Highlight the matching thumbnail visually
                            if (matchedVariant.featured_media) {
                                document.querySelectorAll('.pdp-thumb, .pdp-grid-img').forEach(t => t.classList.remove('active'));
                                const targetThumb = document.querySelector(`[data-media-id="${matchedVariant.featured_media.id}"]`);
                                if (targetThumb) targetThumb.classList.add('active');
                            }
                        }, 150);
                    }
                    
                    // 3. Recalculate Bundles
                    updateBundleMath(matchedVariant.price);
                });
        }
    });
}

// 3. VOLUME PRICING Math & Syncing
function initBundles(sectionId) {
    const bundles = document.querySelectorAll('.bundle-card');
    const qtySelect = document.getElementById(`Quantity-${sectionId}`);
    
    const initialPriceEl = document.getElementById(`Price-${sectionId}`);
    if (initialPriceEl) {
        const initialPriceStr = initialPriceEl.innerText.replace(/[^0-9.]/g, '');
        const initialPriceCents = parseFloat(initialPriceStr) * 100;
        if(!isNaN(initialPriceCents)) updateBundleMath(initialPriceCents);
    }

    bundles.forEach(bundle => {
        bundle.addEventListener('click', function() {
            bundles.forEach(b => {
                b.classList.remove('active');
                const check = b.querySelector('.fa-check');
                if(check) check.classList.add('d-none');
            });
            
            this.classList.add('active');
            const activeCheck = this.querySelector('.fa-check');
            if(activeCheck) activeCheck.classList.remove('d-none');

            if (qtySelect) qtySelect.value = this.getAttribute('data-qty');
        });
    });

    if(qtySelect) {
        qtySelect.addEventListener('change', function() {
            const val = parseInt(this.value);
            let target = val >= 6 ? document.querySelector('.bundle-card[data-qty="6"]') : 
                         val >= 3 ? document.querySelector('.bundle-card[data-qty="3"]') : 
                         document.querySelector('.bundle-card[data-qty="1"]');
            if(target) target.click();
        });
    }
}

function updateBundleMath(priceInCents) {
    const formatMoney = (cents) => '$' + (cents / 100).toFixed(2);
    
    document.querySelectorAll('.bundle-card').forEach(card => {
        const qty = parseInt(card.getAttribute('data-qty'));
        const discountPct = parseInt(card.getAttribute('data-discount') || 0);

        if (qty === 1) {
            const priceEl = card.querySelector('.bundle-price');
            if(priceEl) priceEl.innerHTML = `${formatMoney(priceInCents)}<span class="fw-normal">/each</span>`;
        } else {
            const discountedPrice = priceInCents * (1 - (discountPct / 100));
            const bundlePriceEl = card.querySelector('.bundle-price-discounted');
            const comparePriceEl = card.querySelector('.bundle-compare-price');
            
            if(bundlePriceEl) bundlePriceEl.innerHTML = `${formatMoney(discountedPrice)}<span class="fw-normal">/each</span>`;
            if(comparePriceEl) comparePriceEl.innerHTML = formatMoney(priceInCents);
        }
    });
}